<app-modal-window title="Информация по реферреру"
                  [actions]="false"
                  (close)="close()">
  <div class="referral-info-content">
    <div class="item">
      <span class="field">Пользователь: </span>
      <div class="user-avatar">
        <img src="{{referralDetails.referrer.user.avatar}}"/>
      </div>
      <a [routerLink]="['user/find', referralDetails.referrer.user.id]"
         (click)="close()">{{referralDetails.referrer.user.name}}</a>
    </div>
    <div class="item">
      <span class="field">Код: </span>
      <span>{{referralDetails.code}}</span>
    </div>
    <div class="item">
      <span class="field">Награда: </span>

      <ng-container [ngSwitch]="referralDetails.type">
        <span *ngSwitchCase="'gofast-custom-percent'">{{referralDetails.reward}} %</span>
        <span *ngSwitchDefault
              matTooltip="{{referralDetails.reward | fastCoinsToDollar}}"
              matTooltipPosition="above"
              [matTooltipDisabled]="!isGoFast">
          {{referralDetails.reward / 100 | customCurrency}}
        </span>
      </ng-container>

      <span>({{referralDetails.rewarded ? 'получена' : 'не получена'}})</span>
    </div>
    <div class="item">
      <span class="field">Тип: </span>
      <span>{{typeDictionary[referralDetails.type]}}</span>
    </div>

    <div class="item rewards" *ngIf="referralDetails.userReferralReward?.length">
      <span class="field">Полученные награды: </span>
      <div class="rewards-list">
        <div class="reward-row" *ngFor="let urr of referralDetails.userReferralReward">
          <span class="reward-cell">тип награды: {{ urr.referralCampaignReferralReward?.referralReward?.rewardType || '—' }}</span>
          <span class="reward-cell">тип предмета: {{ urr.referralCampaignReferralReward?.referralReward?.type || '—' }}</span>
          <span class="reward-cell">itemId: {{ urr.referralCampaignReferralReward?.referralReward?.itemId ?? '—' }}</span>
          <span class="reward-cell">value: {{ urr.referralCampaignReferralReward?.referralReward?.value ?? '—' }}</span>
          <span class="reward-cell" *ngIf="!isHiddenRewardDate(urr.createdAt)">получена: {{ urr.createdAt | date: 'dd.MM.yy HH:mm' }}</span>
        </div>
      </div>
    </div>
    <div class="item" *ngIf="referralDetails.activationEndDate">
      <span class="field">Дата окончания активации: </span>
      <span>{{referralDetails.activationEndDate | date: 'dd.MM.yy HH:mm'}}</span>
    </div>
    <div class="item change-code">
      <span class="field">Привязать к другой реф. кампании: </span>
      <div>
        <mat-form-field class="example-form-field">
          <input matInput type="text" [formControl]="refCode">
        </mat-form-field>
        <button class="btn" mat-stroked-button
                color="primary"
                (click)="changeUserRefCode()"
                [disabled]="!refCode.valid">Привязать
        </button>
      </div>
    </div>
  </div>
</app-modal-window>
